import m from "../../@babel/runtime/helpers/esm/extends.mjs";
import * as s from "react";
import f from "../../rc-util/es/Children/toArray.mjs";
import { warning as t } from "../../rc-util/es/warning.mjs";
import p from "./SingleObserver/index.mjs";
import { Collection as d } from "./Collection.mjs";
import "./utils/observerUtil.mjs";
var v = "rc-observer-key";
function u(i, c) {
  var e = i.children, r = typeof e == "function" ? [e] : f(e);
  return process.env.NODE_ENV !== "production" && (r.length > 1 ? t(!1, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.") : r.length === 0 && t(!1, "`children` of ResizeObserver is empty. Nothing is in observe.")), r.map(function(o, n) {
    var l = (o == null ? void 0 : o.key) || "".concat(v, "-").concat(n);
    return /* @__PURE__ */ s.createElement(p, m({}, i, {
      key: l,
      ref: n === 0 ? c : void 0
    }), o);
  });
}
var a = /* @__PURE__ */ s.forwardRef(u);
process.env.NODE_ENV !== "production" && (a.displayName = "ResizeObserver");
a.Collection = d;
export {
  a as default
};
//# sourceMappingURL=index.mjs.map
